import { Alert, Box, Button, Container, Stack, Typography } from '@mui/material';
import useAuth from 'src/hooks/useAuth';

const AccountContextUnavailable = () => {
  const auth = useAuth();
  return (
    <Box minHeight="100vh" display="flex" alignItems="center" bgcolor="background.default">
      <Container maxWidth="sm">
        <Stack spacing={2}>
          <Typography variant="h3">Account temporarily unavailable</Typography>
          <Alert severity="warning">{auth.accountError || 'AutoClever could not load your shop account.'}</Alert>
          <Stack direction="row" spacing={1}>
            <Button variant="contained" onClick={() => window.location.reload()}>Retry</Button>
            <Button variant="outlined" onClick={auth.logout}>Sign out</Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default AccountContextUnavailable;
